module.exports = __webpack_public_path__ + "static/img/enterprise_img_2_cn.72e69c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/enterprise_img_2_cn.png
// module id = cBkn
// module chunks = 0